module.exports = __webpack_public_path__ + "static/media/flowers-min.5ec83361.jpeg";